import { DKLogo } from './design/DKLogo';
import { brand, fontFamily } from '../theme/tokens';

const BOT_USERNAME = 'DreamKissesBot';
const APP_SHORT_NAME = 'app';

/**
 * Fallback screen rendered when the app is opened outside Telegram (e.g.
 * directly in a desktop browser). Encourages users to open via the bot.
 */
export function NotInTelegram() {
  const tgUrl = `https://t.me/${BOT_USERNAME}/${APP_SHORT_NAME}`;
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
        textAlign: 'center',
        background: '#FBF7F8',
        fontFamily,
      }}
    >
      <div style={{ position: 'relative', marginBottom: 24 }}>
        <div
          style={{
            position: 'absolute',
            inset: -10,
            borderRadius: '50%',
            background: brand.gradient,
            opacity: 0.18,
            filter: 'blur(20px)',
          }}
        />
        <div style={{ position: 'relative' }}>
          <DKLogo size={100} />
        </div>
      </div>

      <h1
        style={{
          margin: 0,
          fontSize: 28,
          fontWeight: 800,
          color: '#1A1117',
          letterSpacing: -0.5,
        }}
      >
        DreamKisses
      </h1>

      <p
        style={{
          marginTop: 12,
          marginBottom: 24,
          fontSize: 15,
          color: 'rgba(60,40,50,0.7)',
          maxWidth: 320,
          lineHeight: 1.5,
        }}
      >
        This app runs inside Telegram. Open it from <strong>@{BOT_USERNAME}</strong> to create your kiss video.
      </p>

      <a
        href={tgUrl}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          background: brand.gradient,
          color: '#fff',
          padding: '14px 28px',
          borderRadius: 14,
          textDecoration: 'none',
          fontSize: 15,
          fontWeight: 600,
          boxShadow: brand.glow,
        }}
      >
        Open in Telegram →
      </a>

      <p
        style={{
          marginTop: 32,
          fontSize: 11,
          color: 'rgba(60,40,50,0.4)',
        }}
      >
        For UI development preview, append <code>?dev=1</code> to the URL.
      </p>
    </div>
  );
}
